<script>
  import { getContext } from 'svelte';
  import { format } from 'd3-format';

  import QuadTree from './QuadTree.svelte';

  const { data, width, yScale, config } = getContext('LayerCake');

  const commas = format(',');
  const titleCase = d => d.replace(/^\w/, w => w.toUpperCase());

  export let tooltipOffset = 20;
  export let dataset = undefined;
  export let formatTitle = d => d;
  export let formatKey = d => titleCase(d);
  export let formatValue = d => isNaN(+d) ? d : commas(d);
  export let custom = false;
  export let valueKey = "";
  const w = 100;
  const w2 = 30;
  let top = 0;

  const formatKeyToText = (d) => {
    if(d == 1) {
      return "denne dagen";
    }
    if(d == 2) {
      return "snitt siste 7 dager";
    }
  }

	/* --------------------------------------------
	 * Sort the keys by the highest value
	 */
  function sortResult(result) {
    // if (Object.keys(result).length === 0) return [];
    // const rows = Object.keys(result).filter(d => d !== $config.x).map(key => {
    //   return {
    //     key,
    //     value: result[key]
    //   };
    // }).sort((a, b) => b.value - a.value);
    if(!custom) return result[1];
    if(custom) {
      if (Object.keys(result).length === 0) return [];
    const rows = Object.keys(result).filter(d => d !== $config.x).map(key => {
      return {
        key,
        value: result[key]
      };
    }).sort((a, b) => b.value - a.value);

    return rows;
    }

  }
</script>

<style lang="scss">
	.tooltip {
    display: flex;
		position: absolute;
		font-size: 13px;
    width: 90px;
		pointer-events: none;
		//border: 1px solid #ccc;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
		transform: translate(-50%, -130%);
    padding: 5px;
    z-index: 15;
    pointer-events: none;
  }
  .line {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 1px;
    border-left: 1px dotted #666;
    pointer-events: none;
  }
  .tooltip,
  .line {
    transition: left 150ms ease-out, top 150ms ease-out;
  }
  .title {
    color: color('gray');
   font-weight: 400;
    margin: 0;
    margin-top: 3px;
  }
  .key {
    color: #999;
  }


</style>

<QuadTree
  dataset={dataset || $data}
  y='x'
  let:x
  let:y
  let:visible
  let:found
  let:e
>
  {#if visible === true}
    <div
      style="left:{x}px; "
      class="line"></div>
    <div
      class="tooltip"
      style="
        display: { visible ? 'block' : 'none' };  
        left:{Math.min(Math.max(w2, x), $width - w2)}px;
        top:{tooltipOffset}px;"
      >
      <p class="title">{formatTitle(found[$config.x])}: 
        {#if !custom}
          {formatValue(sortResult(found))}
        {:else}
          {#each sortResult(found) as row}
            <div class="row"><span class="key">{formatKey(row.key)}:</span> {formatValue(row.value)}</div>
          {/each}
        {/if}
      </p>        
    </div>
  {/if}
</QuadTree>


